import { InfoCircleOutlined } from '@ant-design/icons'
import { DatePicker } from 'antd'
import moment from 'moment'
import styled from 'styled-components'
import { FormItem } from 'sutra/components/Form'
import { Input } from 'sutra/components/Input/Input'
import { Tooltip } from 'sutra/components/Tooltip/Tooltip'

import { FormikType } from 'features/project-form/features/source/components/NewSource'

type Props = {
  formik: FormikType
  sourceType: string
}
const dateFormat = 'MM/DD/YYYY'

export const Yotpo = ({ formik }: Props): JSX.Element => {
  return (
    <>
      <FormItem
        label={
          <Tooltip content="Give your source a name to display in the charts. Make sure it's one you'll recognize.">
            <span>
              Source Title <InfoCircleOutlined />
            </span>
          </Tooltip>
        }
        validateStatus={formik.errors.sourceTitle ? 'error' : ''}
        help={formik.errors.sourceTitle}
        wrapperCol={{ span: 10 }}
      >
        <Input
          name="sourceTitle"
          onChange={formik.handleChange}
          value={formik.values.sourceTitle}
          $error={Boolean(formik.errors.sourceTitle)}
          placeholder="Insert title here"
        />
      </FormItem>
      <FormItem
        label={
          <Tooltip content="Select the earliest date from which data should be pulled.">
            <span>
              Date <InfoCircleOutlined />
            </span>
          </Tooltip>
        }
        wrapperCol={{ span: 16 }}
        validateStatus={formik.errors.sourceDate ? 'error' : ''}
        help={formik.errors.sourceDate}
      >
        <DatePicker
          defaultValue={
            formik.values.sourceDate && moment(formik.values.sourceDate)
          }
          onChange={(value) => {
            if (value) {
              formik.setFieldValue('sourceDate', value.toDate())
            }
          }}
          format={dateFormat}
        />
      </FormItem>
      <FormItem
        label={
          <Tooltip content="Provide the Yotpo Product ID.">
            <span>
              Product ID <InfoCircleOutlined />
            </span>
          </Tooltip>
        }
        validateStatus={formik.errors.extra_product_id ? 'error' : ''}
        help={formik.errors.extra_product_id}
        wrapperCol={{ span: 16 }}
      >
        <Flex>
          <Input
            name="extra_product_id"
            onChange={formik.handleChange}
            value={formik.values.extra_product_id}
            $error={Boolean(formik.errors.extra_product_id)}
            placeholder="Insert product ID here"
          />
        </Flex>
      </FormItem>
      <FormItem
        label="API Key"
        validateStatus={formik.errors.access_token ? 'error' : ''}
        help={formik.errors.access_token}
        wrapperCol={{ span: 16 }}
      >
        <Input
          name="access_token"
          onChange={formik.handleChange}
          value={formik.values.access_token || ''}
          $error={Boolean(formik.errors.access_token)}
          placeholder="Insert API Key here"
        />
      </FormItem>
    </>
  )
}

const Flex = styled.div`
  display: flex;
  align-items: center;
`
